import { css } from 'styled-components';
import brand from './brand';
export default css `
  &::-webkit-scrollbar,
  &::-webkit-scrollbar-track {
    background-color: var(--bgColor);

    [data-site='ess'] & {
      --bgColor: ${brand.ess.secondary.lightGrey};
    }

    [data-site='mep'] & {
      --bgColor: ${brand.mep.secondary.midGrey};
    }
  }

  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--fgColor);
    border-radius: 4px;
    cursor: pointer;

    [data-site='ess'] & {
      --fgColor: ${brand.ess.secondary.midGrey};
    }

    [data-site='mep'] & {
      --fgColor: ${brand.ess.secondary.darkGrey};
    }
  }
`;
